"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalseMarkerMethodTectonicCoreFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        constant: true,
        inputs: [],
        name: "isTectonicCore",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x6080604052348015600f57600080fd5b5060818061001e6000396000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c8063a6df963f14602d575b600080fd5b60336047565b604080519115158252519081900360200190f35b60008156fea265627a7a72315820efc62ced11f6257cb22bbc399efa9855498c44ea83da5601e112aff7fc7fddec64736f6c63430005100032";
class FalseMarkerMethodTectonicCoreFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.FalseMarkerMethodTectonicCoreFactory = FalseMarkerMethodTectonicCoreFactory;
FalseMarkerMethodTectonicCoreFactory.bytecode = _bytecode;
FalseMarkerMethodTectonicCoreFactory.abi = _abi;
//# sourceMappingURL=FalseMarkerMethodTectonicCoreFactory.js.map